import React, { Component } from 'react';

export default class Footnotes extends Component {
    render() {
        return (<div>
            <h5>Footnotes</h5>
            <sup>1</sup> For further examples refer to AS 4970-2025, Appendix A, Figure A1. <br />
            <sup>2</sup> For further examples refer to AS 4970-2025, Section 3, Figure 1
        </div>
        );
    }
}